import React, {Component} from 'react';
import "./catalog.sass"
import FirebaseContext from "../../components/Firebase/context";
import Loader from "../../components/commons/Loader/loader";
import {Carousel, Divider} from 'antd';
import {Menu, Icon} from 'antd';
import Privacy from "../privacy/privacy";
import WhoWeAre from "../who_we_are/who_we_are";
import i18next from "../../utils/i18n";
import header from "../../assets/header_bnk.jpg"
import partner from "../../assets/partner.png"

class Catalog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            current: 'home',
            loading: true
        };
    }


    handleClick = e => {
        console.log('click ', e);
        this.setState({
            current: e.key,
        });
    };

    componentDidMount() {
        this.setState({loading: false});
        this.getProduct();
    }


    getProduct() {
        let prod = [];
        this.setState({loading: true});
        this.props.firebase.db.collection("products").get().then((product) => {
            product.forEach((doc) => {
                let document = doc.data();
                document.idDocument = doc.id;
                prod.push(document);
            });
            this.deferSubCat(prod);
        }).catch(error => {
            this.showModal('ERROR', 'Si è verificato un errore. Riprova più tardi!', false);
            console.log(error)
        });
    }

    deferSubCat(prod) {
        prod.map(async (item) => {
            this.props.firebase.db.collection("subCategories").doc(item.subCategoryId).get().then((doc) => {
                item.subCategoryName = doc.data().name;
            });
        });
        setTimeout(function () {
            this.setState({data: prod, loading: false});
        }.bind(this), 1000)
    }

    openMap() {
        window.open('https://goo.gl/maps/7dcF1sh2wRtemjFa6', '_blank');
    }


    render() {
        const {current} = this.state;
        return (
            <div className="catalog_container">
                <div className="up_header_catalog">
                    <div className="logo_catalog"></div>
                    <div className="menu_item">
                        <Menu className="menu_catalog" onClick={this.handleClick} selectedKeys={[this.state.current]}
                              mode="horizontal">
                            <Menu.Item key="home">
                                <Icon type="home" theme={current === 'home' ? 'filled' : ''}/>
                                Home
                            </Menu.Item>
                            <Menu.Item key="catalog">
                                <Icon type="book" theme={current === 'catalog' ? 'filled' : ''}/>
                                Catalogo
                            </Menu.Item>
                            <Menu.Item key="partner">
                                <Icon type="book" theme={current === 'partner' ? 'filled' : ''}/>
                                I nostri Patner
                            </Menu.Item>
                        </Menu>
                    </div>
                </div>
                <div className="divider_header"></div>

                <div className="body_container">
                    {current === 'home' &&
                    <Carousel autoplay>
                        <div>
                            <img src={header}></img>
                        </div>
                        <div>
                            <img src={partner}></img>
                        </div>
                        <div>
                            <h3>3</h3>
                        </div>
                        <div>
                            <h3>4</h3>
                        </div>
                    </Carousel>}

                    {current === 'catalog' && <Carousel autoplay>

                    </Carousel>}

                    {current === 'partner'}


                    {this.state.loading && <Loader/>}
                </div>

                <div className="footer">
                    <div className="info_row_title_catalog">
                        <div className="info_col_img">
                            <div className="logo_cme"></div>
                        </div>
                        <div className="info_col_title_catalog">
                            <label className="who_are_info_title">{i18next.t("CONTACT_US.title_header")}</label>
                            <label className="who_are_info">{i18next.t("CONTACT_US.title_header_2")}</label>
                            <label className="who_are_info">{i18next.t("CONTACT_US.title_header_3")} -  {i18next.t("CONTACT_US.title_header_4")}</label>
                            <label className='informativa_privacy_min'>Prendi visione dell' <a target="_blank" href='/privacy'> informativa sulla privacy</a></label>
                        </div>
                        <div className="info_col_title_catalog">
                            <label className="who_are_info_title">Scopri dove siamo:</label>
                            <div className="info_row_catalog">
                                <Icon  type="car" theme="filled"/>
                                <label className="contact">{i18next.t("CONTACT_US.address")}</label>
                            </div>
                            <div className="info_row_catalog">
                                <Icon  type="phone" rotate={90}/>
                                <label className="contact">{i18next.t("CONTACT_US.number_home")} - {i18next.t("CONTACT_US.number_phone")}</label>
                            </div>
                            <div className="info_row_catalog">
                                <Icon type="mail" theme="filled"/>
                                <label className="contact">{i18next.t("CONTACT_US.email")}</label>
                            </div>
                        </div>
                        <div>
                            <button className="button_cancel" onClick={this.openMap}>Trovaci</button>
                        </div>
                    </div>
                </div>
            </div>

        )
    }

}


Catalog.contextType = FirebaseContext;

export default Catalog;